/** Garde pure : pas d’export CAR sans date « Au » renseignée. */
export function u3125CanExportArAging(body: { asOfDate?: string | null }): boolean {
  return Boolean(body.asOfDate?.trim());
}
